import React from "react";

export const DateToIcon = React.memo(() => (
    <svg
        width="7"
        height="7"
        viewBox="0 0 7 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.50598 1V6.37"
            stroke="black"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1 3.86401L3.506 6.37001L6.012 3.86401"
            stroke="black"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
));

const _DateToIconHoriz = ({ className }) => (
    <svg
        className={className}
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1 3.90234L7.37 3.90234"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.39734 6.875L7.37001 3.90233L4.39734 0.929666"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const DateToIconHoriz = React.memo(_DateToIconHoriz);